/*
 * @Author: your name
 * @Date: 2021-08-03 10:30:02
 * @LastEditTime: 2021-08-05 09:56:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \CJYX_DouYin\src\components\sms\smsTemplate\index.tsx
 */
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Balloon, Button, Dialog, Form, Icon, Input, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import { Servlets } from '@/service';

const FormItem = Form.Item;
/**
 * @param closeDialog 关闭弹窗方法
 * @param selectSms 选择短信方法
 * @param scenes 短信场景 201-预售尾款催付 202-订单催付 203-付款关怀 204-发货提醒 205-确认收货 206-订单催评 207-好评回馈 208-差评安抚 209-退款关怀 210-购后引导入会
 *
 */
const OrderSmsTemplate = (props) => {
  const { closeDialog, selectSms, scenes } = props;
  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 参数
  const [missionParams, setMissionParams] = useState({
    templateId: '',
    templateContent: '',
  });
  const [tableList, setTableList] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  // 短信签名
  const [sign, setSign] = useState('');
  // 请求表格数据
  const getList = (v) => {
    v.channelType = 1; // 0-营销短信模板 1-关怀类短信模板
    v.templateType = 1; // 模板类型，0是自定义，1是系统模板
    v.scenes = +scenes; // 短信场景
    setListLoading(true);
    Servlets('getSmsTemplate', v).then((res) => {
      // console.log('🚀res.data===', res.data);
      // +2是 签名两侧【】
      res.data.forEach((item) => {
        item.wordCount = item.templateContent.length;
        if ((sign.length + item.wordCount + 2) <= 70) {
          item.smsNum = Math.ceil((sign.length + item.wordCount + 2) / 70);
        } else if ((sign.length + item.wordCount + 2) > 70) {
          item.smsNum = Math.ceil((sign.length + item.wordCount + 2) / 67);
        }
      });
      setTableList(res.data);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setListLoading(false);
    })
      .catch(() => {
        setListLoading(false);
      });
  };
  // 选择
  const oprate = (value, index, record) => {
    return (
      <Button
        type="primary"
        style={{ color: '#3399FF', flex: '1', textAlign: 'left' }}
        text
        onClick={() => {
          selectSms(record);
          closeDialog();
        }}
      >选择
      </Button>
    );
  };
  const listSizeChange = (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      const tempParams = { ...missionParams };
      tempParams.pageNo = pages.pageNo;
      tempParams.pageSize = pages.pageSize;
      getList(tempParams);
    } catch (e) {
    }
  };
  // 查询
  const search = () => {
    const params = {
      templateId: missionParams.templateId,
      templateContent: missionParams.templateContent,
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    };
    getList(params);
  };
  // 重置
  const reset = () => {
    setMissionParams({ templateId: '', templateContent: '' });
    setPageInfo({ ...pageInfo, pageNo: 1 });
    const params = {
      templateId: '',
      templateContent: '',
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    };
    getList(params);
  };
  useEffect(() => {
    search();
    // 获取短信签名
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        setSign(res.data);
      }).catch((e) => {
        console.log(e);
      });
    });
  }, []);

  return (
    <>
      <Dialog
        isFullScreen
        shouldUpdatePosition
        className="sms-template-dialog"
        title="短信文案选择"
        visible
        onClose={closeDialog}
        style={{ width: 1060 }}
        footer={false}
      >
        <div style={{ padding: 10 }}>
          <div className={styles.warning}>
            <div className={styles.item}>
              <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
              <span>1.模板内已计算“短信签名”和“退订请回复X”字数。</span>
            </div>
            <div style={{ paddingLeft: 24, marginTop: 2 }}>2.短信内的变量，如#PayLink#、#CustomerName#等，短信发送时依据获取的实际信息进行自动替换，短信字数以替换后的实际字数为准，请知悉。</div>
          </div>
          <div className={styles.box}>
            <Form>
              <div className={styles.inputBox}>
                <div className={styles.con} style={{ marginRight: 20 }}>
                  <FormItem>
                    <div>模板ID：</div>
                    <Input
                      placeholder="请输入模板ID"
                      aria-label="Medium"
                      aria-labelledby="J_InputMedium"
                      style={{ width: '100%', marginTop: 10 }}
                      value={missionParams.templateId}
                      onChange={(v) => {
                        setMissionParams({ ...missionParams, templateId: v });
                      }}
                      name="templateId"
                    />
                  </FormItem>
                </div>
                <div className={styles.con}>
                  <FormItem>
                    <div>关键字：</div>
                    <Input
                      placeholder="请输入关键字"
                      aria-label="Medium"
                      aria-labelledby="J_InputMedium"
                      style={{ width: '100%', marginTop: 10 }}
                      value={missionParams.templateContent}
                      onChange={(v) => {
                        setMissionParams({ ...missionParams, templateContent: v });
                      }}
                      name="keyWords"
                    />
                  </FormItem>
                </div>
                <div className={styles.CheckButtonBox} style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                  <FormItem>
                    <div>
                      <Form.Submit type="primary" onClick={search} className={styles.btn} style={{ marginRight: 10 }}>查询</Form.Submit>
                      <Form.Reset className={styles.btn} onClick={reset}>重置</Form.Reset>
                    </div>
                  </FormItem>
                </div>
              </div>
            </Form>
          </div>
          {/* 表格 */}
          <div className={styles.orderTable}>
            <Table dataSource={tableList} loading={listLoading} fixedHeader>
              <Table.Column title="模板ID" dataIndex="templateId" width="120px" align="left" />
              <Table.Column
                title="短信内容"
                align="left"
                cell={(value, index, record) => (
                  <div>
                    {
                    (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={styles.limit2}>{
                          `【${sign}】${record.templateContent}`
                        }
                        </div>
                        <Balloon
                          align="t"
                          shouldUpdatePosition
                          closable={false}
                          trigger={<Button type="primary" style={{ color: '#3399FF', marginLeft: '4px' }} text>详情</Button>}
                        >
                          {
                            <div key={index}>
                              {`【${sign}】${record.templateContent}`}
                            </div>
                          }
                        </Balloon>
                      </div>
                    )
                  }
                  </div>
                )}
              />
              <Table.Column
                title="字数/计费条数"
                dataIndex="wordCount"
                align="left"
                width="160px"
                cell={(value, index, record) => {
                  return <div>{`${record.wordCount + 2 + sign.length} / ${record.smsNum}`}</div>;
                }}
              />
              <Table.Column title="操作" width="80px" cell={oprate} align="left" />
            </Table>
          </div>
          <div>
            <LzPagination pageInfo={pageInfo} onChange={listSizeChange} />
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default OrderSmsTemplate;
